// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + ({"12":"profiler","526":"pages-DebugPage","777":"recorder"}[chunkId] || chunkId) + "-" + {"12":"dab9b6698941103a5e50","526":"05112aecdc38d96fb933","748":"ef8c40f4d2d761b7d785","777":"c047faf0c2155797bf93"}[chunkId] + ".js";
};